module.exports = __webpack_public_path__ + "media/images/icons/location-20cb3f3082dbd3ff12fc4c953ba4e3e3.svg";